import Ajax from '../ajax'

export default {
  getFarmInfo: (userId) => Ajax('get', `account/getFarmInfo/${userId}`),
  applyFarm: (data) => Ajax('post', 'apply/info', data)
}
